import { jsx } from 'react/jsx-runtime';
import { Flex } from '@fabric-app/ui/components/Flex';
import { styled } from 'styled-components';
import { useExpandedFdocContext } from '../../ExpandedFdoc/ExpandedFdocProvider.js';

const FloatingBar = styled(Flex).attrs((props) => {
  return {
    gap: "elementsContainer",
    alignItems: "center",
    ...props
  };
}).withConfig({
  displayName: "ModalExpandedResourceFloatingBottomContainer__FloatingBar",
  componentId: "sc-e77929ef-0"
})([
  `position:absolute;left:1rem;bottom:calc(1rem + `,
  `px);z-index:30;height:40px;`
], (p) => p.offset);
const ModalExpandedResourceFloatingBottomContainer = ({ children, className }) => {
  const { toolbarHeight } = useExpandedFdocContext();
  return /* @__PURE__ */ jsx(FloatingBar, {
    className,
    offset: toolbarHeight,
    children
  });
};

export { ModalExpandedResourceFloatingBottomContainer };
//# sourceMappingURL=ModalExpandedResourceFloatingBottomContainer.js.map
